// 🟦 = blocked
// ⬜ = selected
// ⬛ = empty
// 🔳 = seat/click

export default {

  '⬜⬛🔳⬛⬜': [
    ({ seat, block }) => block.isSelected(1) && block.isSelected(-1) && seat.isNotEdge(),
    ({ seat }) => ({
      select: seat.edge(),
      valid: false,
      stop: true,
    })
  ],

  '⬜🔳⬛🔳⬜': [
    ({ seat, block }) => block.isSelected(1) && block.isSelected(-1) && seat.isEdge(),
    ({ seat }) => ({
      valid: true,
      stop: true,
    })
  ],

  '🔳⬛⬛⬜⬜': [
    ({ seat, block }) => block.isSelected(1) && seat.isNotLast(),
    ({ seat }) => ({
      select: seat.last(),
      valid: false,
      stop: true,
    })
  ],

  '⬜⬜⬛⬛🔳': [
    ({ seat, block }) => block.isSelected(-1) && seat.isNotFirst(),
    ({ seat }) => ({
      select: seat.first(),
      valid: false,
      stop: true,
    })
  ],

}
